import events from 'events';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';

const CHANGE_EVENT = 'change';
let _viewingMainContent = 0;
let _currentSlide = 0;
let _showLargeLanding = true;
let _sectionTransitionComplete = false;

const EmojiIsLifeStore = Object.assign({}, events.EventEmitter.prototype, {
  /**
   * Returns the current breakpoint
   * @returns {String} the current breakpoint
   */
  getState() {
    return {
      viewingMainContent: _viewingMainContent,
      currentSlide: _currentSlide,
      showLargeLanding: _showLargeLanding,
      sectionTransitionComplete: _sectionTransitionComplete,
    };
  },


  /**
   * Emits change event
   * @returns {undefined} undefined
   */
  emitChange() {
    this.emit(CHANGE_EVENT);
  },


  /**
   * Ads a listener function to the store
   * @param {Function} callback A function to add as a callback
   * @returns {undefined} undefined
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },


  /**
   * Removes a listener function from the store
   * @param {Function} callback A function to remove from the callbacks
   * @returns {undefined} undefined
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },


  /**
   * Listens for events and takes action accordingly
   * @returns {Boolean} true
   */
  dispatcherIndex: AppDispatcher.register((payload) => {
    const action = payload.action;

    switch (action.actionType) {

      case AppConstants.GO_TO_LANDING_CONTENT:
        _viewingMainContent = false;

        EmojiIsLifeStore.emitChange();
        break;

      case AppConstants.GO_TO_MAIN_CONTENT:
        _viewingMainContent = true;

        EmojiIsLifeStore.emitChange();
        break;

      case AppConstants.SLIDE_CHANGED:
        _currentSlide = action.slide;

        EmojiIsLifeStore.emitChange();
        break;

      case AppConstants.REMOVE_LARGE_LANDING:
        _showLargeLanding = false;

        EmojiIsLifeStore.emitChange();
        break;

      case AppConstants.SHOW_LARGE_LANDING:
        _showLargeLanding = true;

        EmojiIsLifeStore.emitChange();
        break;

      case AppConstants.SECTION_TRANSITION_COMPLETE:
        _sectionTransitionComplete = true;

        EmojiIsLifeStore.emitChange();
        break;

      case AppConstants.SECTION_TRANSITION_IN_PROGRESS:
        _sectionTransitionComplete = false;

        EmojiIsLifeStore.emitChange();
        break;

      default:
        break;
    }

    return true;
  }),
});

module.exports = EmojiIsLifeStore;



/** WEBPACK FOOTER **
 ** ./assets/js/src/stores/EmojiIsLifeStore.js
 **/